<template>
    <div class="widget email-template-publish-widget">
        <div class="widget-header">
            <h3>Publish to Partners</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>Please select which partners you would like this non-graphical email template to be published to:</p>
            <client-published-email-template-table
                :emailTemplateId="emailTemplateId"
                @update:selectedItems="updateSelectedClients($event)"
            ></client-published-email-template-table>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button @click="save" :loading="isSaving">
                    {{ isSaving ? 'Saving' : 'Save' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const ClientPublishedEmailTemplateTable = () => import('@/components/client/client-published-email-template-table');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'email-template-publish-widget',

    props: ['options', 'widget'],

    components: {
        'app-button': AppButton,
        'client-published-email-template-table': ClientPublishedEmailTemplateTable,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isInitializing: true,
            isSaving: false,
            emailTemplateId: null,
            agencyId: null,
            selectedClients: []
        }
    },

    computed: {
        
    },

    methods: {
        updateSelectedClients(selectedClients) {
            this.selectedClients = selectedClients;
        },

        save() {  
            this.isSaving = true;
            var clientIds = this.selectedClients.map(client => { return client.id });

            this.$api
                .post(`/api/EmailTemplates/${ this.emailTemplateId }/Publish`, clientIds)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your publish settings have been updated.');
                    this.isSaving = false;
                    
                    EventBus.$emit('email-template:update');
                    this.closeWidget();
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while saving your publish settings.', { error });
                    this.isSaving = false;
                });          
        },

        getTemplate() {
            this.$api
                .get(`/service/EmailTemplates/?$filter=Id eq ${ this.emailTemplateId }`)
                .then(response => {
                    this.agencyId = response.data.value[0].AgencyId;                    
                    this.isInitializing = false;
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while getting your template settings.', { error });
                    this.closeWidget();
                    this.isInitializing = false;
                }); 
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.emailTemplateId = this.options.emailTemplateId;
        this.getTemplate();
    },

    destroyed() {
        
    }
}
</script>

<style scoped>
.email-template-publish-widget .saving-step {
    text-align: center;
}

.email-template-publish-widget .content-wrapper {
    padding: 20px;
}

.email-template-publish-widget .action-container {
    display: flex;
}

.email-template-publish-widget .action-container .btn {
    margin-left: 15px;
}

.email-template-publish-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.email-template-publish-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.email-template-publish-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}
</style>
